import { FileTypeEnum, IFile } from '@repo/toolkit/types'
import { UploadIcon } from '@repo/ui/icons'
import Modal, { MODAL_BODY_CLASSNAME } from '@repo/ui/modal'
import { useMutation } from '@tanstack/react-query'

import { Files } from '../../../lib/constants/files'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { uploadFile } from '../../../lib/utils/functions/file.functions'
import { UploadFileForm } from '../forms/upload-file.form'

type UploadCsvModalProps = {
  title?: string
  isOpen: boolean
  onClose: () => void
  onUpload?: (file: IFile) => Promise<void>
}

export function UploadCsvModal({ onClose, onUpload, ...props }: UploadCsvModalProps) {
  const { mutateAsync } = useMutation({
    mutationFn: (file: IFile) => uploadFile(Files.TEMPORARY_FILES, file),
    onSuccess: async (response) => {
      if (response) await onUpload?.(response)
      onClose()
    }
  })

  return (
    <Modal {...props} onCancel={onClose} size={'small'} hideActions icon={UploadIcon}>
      <div className={MODAL_BODY_CLASSNAME}>
        <UploadFileForm
          allowedTypes={[FileTypeEnum.SHEET]}
          buttonsConfig={twoButtonsConfig({
            onConfirm: async ({ file }) => await mutateAsync(file),
            onCancel: onClose
          })}
        />
      </div>
    </Modal>
  )
}
